<script>
import { ShoppingCart, Location, Merchant, Account } from './../../functions.js'
import LocationAPI from './../../api/location.js'
import AccountAPI from './../../api/account.js'

import LocationSelection from './LocationSelection.vue'

export default {
  name: 'AddressFormModal',
   props: {
      allowClose: {
      type: Boolean,
        default: true
      },
      mode: {
      type: String,
        default: 'add'
      },
      selected_address: {
      type: Object,
        default: {}
      },
      selected_index: {
      type: Number,
        default: 0
      },

  },
   watch: {
    error_message (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value != '') {
        setTimeout(() => {
          this.show_error = false;
          this.error_message = '';
        }, 5000)
      }
    }
  },
  data () {
    return {
      Account,
      submitting: false,
      show_error: false,
      error_message: '',
        province_list: [],
      city_list: [],
      barangay_list: [],
      label: '',
      address: '',
      province: "",
      city: "",
      barangay: "",
      landmark: '',
      is_default: false,
    }
  },
  components: {
    LocationSelection
  },
  methods: {
    closeModal () {
      this.$emit('onClose');
    },
    validateSubmit () {
        var error = {
            message: '',
            has_error: 0
        }

         if (this.address == '' || this.address == null) {
            error.message = 'Please enter your address'
            error.has_error = 1
            return error
        }  else if (this.province == "") {
            error.message = 'Please select a province'
            error.has_error = 1
            return error
        } else if (this.city == "") {
            error.message = 'Please select a city'
            error.has_error = 1
            return error
          } else if (this.barangay == "") {
            error.message = 'Please select a barangay'
            error.has_error = 1
            return error
          }

        return error
    },
    async submit()
    {
       this.show_error = false
       this.error_message = ''

        var validation = this.validateSubmit()
        if (validation.has_error) {
            this.show_error = true
            this.error_message = validation.message

        } else {          
          // var account_info = this.Account.getInfo();
          // if(account_info)
          // {
          //   if(account_info.addresses.length)
          //   {
          //      // If the newly added address is set to default address, change other address is_default value to false
          //     if(this.is_default == true)
          //     {
          //       account_info.addresses.forEach((address, address_index)=>{
          //         address.is_default = false;
          //       });
          //     }
          //   }
          //   else
          //   {
          //     // Auto set default address if there's no other existing address in the list
          //     this.is_default = true;  
          //   }

          //   if(this.mode == "add")
          //   {
          //     account_info.addresses.push({
          //       label: this.label,
          //       location: this.address,
          //       prov: this.mapProvince(this.province),
          //       citymun:  this.mapCity(this.city),
          //       brgy:  this.mapBrgy(this.barangay),
          //       is_default: this.is_default,
          //       landmark: this.landmark
          //     });

          //      try {
          //         var login_id = this.Account.getLoginId();
          //         var token = this.Account.getToken();
          //         var update_details_request = AccountAPI.updateAccountInfo(login_id, token, account_info.first_name, account_info.last_name, account_info.mobile_number, account_info.email, account_info.addresses);
          //         update_details_request.then((response) =>{
          //         if(response.status == 'success' || response.status == 'Success')
          //         {
          //             this.Account.setInfo(account_info);
          //             this.$emit('onClose', 'Address has been added');
          //         }
          //         else
          //         {
          //             console.log(response);
          //         }
          //     });
          //     } catch (error) {
          //         console.log(error);
                 
          //     }

             
          //   }
          //   else if(this.mode == "edit")
          //   {
          
          //     account_info.addresses[this.selected_index].label = this.label;
          //     account_info.addresses[this.selected_index].location = this.address;
          //     account_info.addresses[this.selected_index].is_default = this.is_default;
          //     account_info.addresses[this.selected_index].landmark = this.landmark;
          //     account_info.addresses[this.selected_index].prov = this.mapProvince(this.province);
          //     account_info.addresses[this.selected_index].citymun = this.mapCity(this.city);
          //     account_info.addresses[this.selected_index].brgy =  this.mapBrgy(this.barangay);
  
          //       try {
          //         var login_id = this.Account.getLoginId();
          //         var token = this.Account.getToken();
          //         var update_details_request = AccountAPI.updateAccountInfo(login_id, token, account_info.first_name, account_info.last_name, account_info.mobile_number, account_info.email, account_info.addresses);
          //         update_details_request.then((response) =>{
          //         if(response.status == 'success' || response.status == 'Success')
          //         {
          //             this.Account.setInfo(account_info);
          //             this.$emit('onClose', 'Address has been updated');
          //         }
          //         else
          //         {
          //             console.log(response);
          //         }
          //     });
          //     } catch (error) {
          //         console.log(error);
                 
          //     }
          //   }
          //   else if(this.mode == "remove")
          //   {
          //        account_info.addresses.splice(this.selected_index,1);
          //       try {
          //         var login_id = this.Account.getLoginId();
          //         var token = this.Account.getToken();
          //         var update_details_request = AccountAPI.updateAccountInfo(login_id, token, account_info.first_name, account_info.last_name, account_info.mobile_number, account_info.email, account_info.addresses);
          //         update_details_request.then((response) =>{
          //         if(response.status == 'success' || response.status == 'Success')
          //         {
          //             this.Account.setInfo(account_info);
          //             this.$emit('onClose', 'Address has been removed');
          //         }
          //         else
          //         {
          //             console.log(response);
          //         }
          //     });
          //     } catch (error) {
          //         console.log(error);
                 
          //     }

          //   }
          // }
          // else
          // {
          //   console.log("No Account Info Found");
          // }
          var account_info = Account.getInfo();
          var login_id = Account.getLoginId();
          var token = Account.getToken();
          var create_customer_address = AccountAPI.createSubAccount(
            this.province,
            this.city,
            this.barangay,
            this.address,
            account_info.email,
            login_id,
            token
            );
          create_customer_address.then((response)=>{
            if((response.status).toLowerCase() == 'success')
            {
               this.$emit('onClose', 'Address has been added and is subject for approval');
            }
            else
            {
                this.show_error = true
                this.error_message = response.message
            }
          });
        }

    },
    async loadProvinces()
    {
      var province_request = LocationAPI.getProvinces()
        province_request.then((response) => {
          if (response.length) {
            this.province_list = response
            return this.province_list;
          }
        });
        return province_request;
     },
    async loadCities (province_code) {
      this.city_list = [];

      var city_request = LocationAPI.getCities(province_code)
      city_request.then((response) => {
        if (response.length) {
          this.city_list = response;
          return this.city_list;
        }
      })
    },
    async loadBarangay (city_code) {
      this.barangay_list = [];

      var barangay_request = LocationAPI.getBarangay(city_code)
      barangay_request.then((response) => {
        if (response.length) {
          this.barangay_list = response;
          return this.barangay_list;
        }
      })
    },
    mapProvince(province_code)
    {
      var prov = null;
      this.province_list.forEach((province, province_index)=>{
        if(province.psgcCode == province_code)
        {
          prov = province;
        }
      });

      return prov;
    },
    mapCity(city_code)
    {
      var ct = null;
      this.city_list.forEach((city, city_index)=>{
        if(city.citymunCode == city_code)
        {
          ct = city;
        }
      });

      return ct;
    },
    mapBrgy(brgy_code)
    {
      var bgy = null;
      this.barangay_list.forEach((brgy, brgy_index)=>{
        if(brgy.brgyCode == brgy_code)
        {
          bgy = brgy;
        }
      });

      return bgy;
    },
    

  },
  mounted () {
    try {
      if(this.selected_address)
      {
        this.label = this.selected_address.label;
        this.landmark = this.selected_address.landmark;
        this.address = this.selected_address.location;
        this.is_default = this.selected_address.is_default;

         // Load Province List only
        this.loadProvinces().then((response) => {
          if (response.length) {
            this.province_list = response;
            this.province = this.selected_address.prov.psgcCode;

            this.loadCities(this.province).then((city_response)=>{
              this.city = this.selected_address.citymun.citymunCode;

              this.loadBarangay(this.city).then((barangay_response)=>{
                this.barangay = this.selected_address.brgy.brgyCode;
              });
            });
          }
        })
      }
      else
      {
        // Load Province List only
        this.loadProvinces(); 
      }



    } catch (error) {

    }
  }
}
</script>
<template>

    <!-- MODAL AREA START (Locations Modal) -->
     <div class="location-modal-wrapper">
      <div class="ltn__modal-area ltn__address-form-area">
          <div class="modal fade show" id="address_form_modal" tabindex="-1" style="display:block;">
              <div class="modal-dialog modal-md" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <button type="button" class="close" v-if="allowClose" @click="closeModal()" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                          </button>
                      </div>
                      <div class="modal-body">
                           <div class="ltn__quick-view-modal-inner">
                               <div class="modal-location-select">
                                  <div class="row">
                                      <div class="col-12">
                                           <div class="modal-location-form" v-if="mode != 'remove'">
                                              <h5>{{ mode == "add" ? "Add New Address" : "Edit Address" }}</h5>
                                     

                                               <div v-if="show_error" class="alert alert-danger" role="alert">
                                                {{ error_message }}
                                              </div>
                                              <div class="fields">
                                              <div class="row">
                                                
                                                <div class="col-12 col-md-12">
                                                  <input type="text" v-model="address" placeholder="Unit No., Building, Street Name">
                                                </div>

                                              </div>
                                              
                                              <div class="row mb-10">
                                                <div class="col-12">
                                                  <select @change="loadCities(province)" class="c-select" v-model="province">
                                                    <option selected disabled value="">Select Province</option>
                                                    <option v-for="province in province_list" :value="province.psgcCode">{{ province.provDesc }}</option>
                                                  </select>
                                                </div>
                                                <div class="col-12">
                                                  <select @change="loadBarangay(city)" class="c-select" :disabled="!city_list.length" v-model="city">
                                                  <option selected disabled value="">Select City</option>
                                                  <option v-for="city in city_list" :value="city.citymunCode">{{ city.citymunDesc }}</option>
                                                </select>
                                                </div>
                                                <div class="col-12">
                                                  <select class="c-select" :disabled="!barangay_list.length" v-model="barangay">
                                                  <option selected disabled value="">Select Barangay</option>
                                                  <option v-for="barangay in barangay_list" :value="barangay.brgyCode">{{ barangay.brgyDesc }}</option>
                                                </select>
                                                </div>
                                              </div>
                                              </div>
                                              
                                              <div class="btn-wrapper">
                                                  <button @click="submit" class="theme-btn-2 btn btn-effect-2">{{ submitting ? 'Loading...' : 'Submit' }}</button>
                                              </div>
                                           </div>
                                           <div class="modal-location-form" v-if="mode == 'remove'">
                                              <h5>Are you sure you want to remove this address?</h5>
                                               <address class="address">
                                                  <p>
                                                      <strong >{{ selected_address.label }}</strong><br>
                                                      {{ selected_address.location }}<br>
                                                      {{ selected_address.brgy.brgyDesc }}, {{ selected_address.citymun.citymunDesc }}<br>
                                                      <span v-if="selected_address.landmark">Landmark: {{ selected_address.landmark }}<br></span>
                                                      <small v-if="selected_address.is_default">Default Address</small><br>
                                                  </p>
                                              </address>
                                              <div class="btn-wrapper">
                                                  <button @click="submit" class="theme-btn-2 btn btn-effect-2">{{ submitting ? 'Loading...' : 'Yes' }}</button>
                                                   <button @click="closeModal" class="theme-btn-2 btn btn-effect-2">{{ submitting ? 'Loading...' : 'No' }}</button>
                                              </div>
                                           </div>
                                      </div>
                                  </div>
                               </div>
                           </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="modal-backdrop fade show">
      </div>
     </div>
    <!-- MODAL AREA END -->
</template>

<style>
.location-modal-wrapper {
    position: relative;
    z-index: 10000;
}
.modal-location-form select {
    width: 100%;
    height: 4rem;
    margin-bottom: 1rem;
    padding: 0px 10px;
}

.location-modal-wrapper .modal-location-form .btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}
.location-modal-wrapper .modal-location-form .btn-wrapper button {
    width: 100%;
}

div#address_form_modal .modal {
    position: fixed;
    top: -75px;
    left: 0;
    z-index: 1050;
    display: none;
    width: 100%;
    /* height: 100%; */
    overflow: hidden;
    outline: 0;
}
.fields {
    height: auto;
    max-height: 200px;
    overflow: hidden;
    overflow-y: scroll;
}
/* width */
.fields::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.fields::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
.fields::-webkit-scrollbar-thumb {
  background: #000; 
}

/* Handle on hover */
.fields::-webkit-scrollbar-thumb:hover {
  background: #020202; 
}
@media (min-width: 576px)
div#address_form_modal .modal-dialog {
    max-width: 676px !important;
    margin: 1.75rem auto;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/AddressFormModal.vue